// Reads VITE_BILLING_TEST_MODE and exposes a shared boolean.
// Used by SubscribeModal / TopUpModal (to inject test_mode:true into the
// request) and by BillingPage (to render a visible banner).
export function isTestMode(): boolean {
  const v = import.meta.env.VITE_BILLING_TEST_MODE;
  return v === 'true' || v === '1';
}
